import { ResourceBlock, useRepositoryQuery } from '@mews-commander/data-access';
import { TableState } from '@optimus-web/core';
import { ResourceBlocksFilterValues } from '../../filters';

interface useResourceBlocksTableQueryParams {
    filterValues: ResourceBlocksFilterValues;
    tableState: TableState<ResourceBlock>;
}

export const useResourceBlocksTableQuery = ({ filterValues, tableState }: useResourceBlocksTableQueryParams) => {
    const { pagination } = tableState;
    const { startDate, endDate } = filterValues;

    return useRepositoryQuery('resourceBlocks', 'getAll', {
        collidingIntervalUtc: {
            startUtc: startDate,
            endUtc: endDate,
        },
        count: pagination.pageSize,
        startIndex: pagination.pageIndex * pagination.pageSize,
    });
};
